import request from '../network';
import formData from "form-data";
import { fileToBase64 } from './AssetService';
import { TranscriptResponse } from '../types/SpeechToText';
export const uploadSpeechFile = async (file: File) => {
    const form = new formData();
    const file1 = await fileToBase64(file) as string;
    form.append('file', file1.split('base64,')[1]);
    form.append('file_name', file.name);
    return await request.POST<TranscriptResponse>('/api/speech_to_text/transcript', form).then((response) => response).catch((error) => error);
};

export const getSpeechText = async (jobID: string) => {
    return await request.POST<TranscriptResponse>('/api/speech_to_text/get_text', {
        job_id: jobID,
    }).then((response) => response).catch((error) => error);
};

export const getSpeechList = async () => {
    return await request.GET<TranscriptResponse[]>('/api/speech_to_text/list').then((response) => response).catch((error) => error);
};